<template>
  <div>
    <div v-for="item in list" :class="[item.activityType==1?'':item.activityType==2?'service':item.activityType==3?'plan':item.activityType==4?'activity':'','card','mat20']">
      <div class="title">
        <!-- activityType 1讲解 2服务 3策划 4其他活动  -->
        <span class="name" v-if="item.activityType==1">讲解</span>
        <span class="name" v-if="item.activityType==2">服务</span>
        <span class="name" v-if="item.activityType==3">策划</span>
        <span class="name" v-if="item.activityType==4">其他活动</span>

        <span class="more" @click="$router.push({name:'myServiceList',params:{type:'explain'}})" v-if="item.activityType==1">查看&nbsp;></span>
        <span class="more" @click="$router.push({name:'myServiceList',params:{type:'service'}})" v-if="item.activityType==2">查看&nbsp;></span>
        <span class="more" @click="$router.push({name:'myServiceList',params:{type:'plan'}})" v-if="item.activityType==3">查看&nbsp;></span>
        <span class="more" @click="$router.push({name:'myServiceList',params:{type:'activity'}})" v-if="item.activityType==4">查看&nbsp;></span>
      </div>
      <div class="circle circle-sm">
        <div class="item" v-for="cItem in item.countList">
          <i class="iconfont icon-jiangjiedian" v-show="cItem.activityStatus==1"></i>
          <i class="iconfont icon-icon02" v-show="cItem.activityStatus==2"></i>
          <i class="iconfont icon-icon02" v-show="cItem.activityStatus==3"></i>
          <i class="iconfont icon-dui" v-show="cItem.activityStatus==4"></i>
          <i class="iconfont icon-shalou" v-show="cItem.activityStatus==5"></i>
          <i class="iconfont icon-yiquxiao" v-show="cItem.activityStatus==6"></i>
          <div>
            <div class="num">{{cItem.count}}</div>
            <div class="text">{{cItem.showName}}</div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="card mat20 service" v-if="userMess.applyPost==2">
      <div class="title">
        <span class="name">服务</span>
        <span class="more" @click="$router.push({name:'myServiceList',params:{type:'service'}})">查看&nbsp;></span>
      </div>
      <div class="circle circle-md">
        <div class="item">
          <i class="iconfont icon-jiangjiedian"></i>
          <div>
            <div class="num">13,454</div>
            <div class="text">全部</div>
          </div>
        </div>
        <div class="item">
          <i class="iconfont icon-dui"></i>
          <div>
            <div class="num">13,454</div>
            <div class="text">已完成</div>
          </div>
        </div>
      </div>
      <div class="circle circle-sm">
        <div class="item">
          <i class="iconfont icon-yiwancheng4"></i>
          <div>
            <div class="num">13,454</div>
            <div class="text">已领取</div>
          </div>
        </div>
        <div class="item">
          <i class="iconfont icon-icon02"></i>
          <div>
            <div class="num">13,454</div>
            <div class="text">进行中</div>
          </div>
        </div>
        <div class="item">
          <i class="iconfont icon-yiquxiao"></i>
          <div>
            <div class="num">13,454</div>
            <div class="text">已取消</div>
          </div>
        </div>
        <div class="item">
          <i class="iconfont icon-shalou"></i>
          <div>
            <div class="num">13,454</div>
            <div class="text">审核中</div>
          </div>
        </div>
      </div>
    </div>
    <div class="card mat20 plan" v-if="userMess.applyPost==3">
      <div class="title">
        <span class="name">策划</span>
        <span class="more" @click="$router.push({name:'myServiceList',params:{type:'plan'}})">查看&nbsp;></span>
      </div>
      <div class="circle circle-md">
        <div class="item">
          <i class="iconfont icon-jiangjiedian"></i>
          <div>
            <div class="num">13,454</div>
            <div class="text">全部</div>
          </div>
        </div>
        <div class="item">
          <i class="iconfont icon-dui"></i>
          <div>
            <div class="num">13,454</div>
            <div class="text">已完成</div>
          </div>
        </div>
      </div>
      <div class="circle circle-sm">
        <div class="item">
          <i class="iconfont icon-yiwancheng4"></i>
          <div>
            <div class="num">13,454</div>
            <div class="text">已领取</div>
          </div>
        </div>
        <div class="item">
          <i class="iconfont icon-icon02"></i>
          <div>
            <div class="num">13,454</div>
            <div class="text">进行中</div>
          </div>
        </div>
        <div class="item">
          <i class="iconfont icon-yiquxiao"></i>
          <div>
            <div class="num">13,454</div>
            <div class="text">已取消</div>
          </div>
        </div>
        <div class="item">
          <i class="iconfont icon-shalou"></i>
          <div>
            <div class="num">13,454</div>
            <div class="text">审核中</div>
          </div>
        </div>
      </div>
    </div>
    <div class="card mat20 activity">
      <div class="title">
        <span class="name">其他活动</span>
        <span class="more" @click="$router.push({name:'myServiceList',params:{type:'activity'}})">查看&nbsp;></span>
      </div>
      <div class="circle circle-md">
        <div class="item">
          <i class="iconfont icon-jiangjiedian"></i>
          <div>
            <div class="num">13,454</div>
            <div class="text">全部</div>
          </div>
        </div>
        <div class="item">
          <i class="iconfont icon-dui"></i>
          <div>
            <div class="num">13,454</div>
            <div class="text">已完成</div>
          </div>
        </div>
      </div>
      <div class="circle circle-sm">
        <div class="item">
          <i class="iconfont icon-yiwancheng4"></i>
          <div>
            <div class="num">13,454</div>
            <div class="text">已领取</div>
          </div>
        </div>
        <div class="item">
          <i class="iconfont icon-icon02"></i>
          <div>
            <div class="num">13,454</div>
            <div class="text">进行中</div>
          </div>
        </div>
        <div class="item">
          <i class="iconfont icon-yiquxiao"></i>
          <div>
            <div class="num">13,454</div>
            <div class="text">已取消</div>
          </div>
        </div>
        <div class="item">
          <i class="iconfont icon-shalou"></i>
          <div>
            <div class="num">13,454</div>
            <div class="text">审核中</div>
          </div>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      list: [],
      type: "",
      userMess: this.$store.state.user.user,
    };
  },
  computed: {
    classType() {

      return {
        active: this.isActive,
      }
    }
  },
  watch: {},
  methods: {
    getDetail() {
      this.$api.getActivityStatistic({ volunteerId: this.userMess.id }).then(res => {
        // console.log(res)
        this.list = res.data
      })
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() { },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.getDetail()


  },
  beforeCreate() { }, //生命周期 - 创建之前
  beforeMount() { }, //生命周期 - 挂载之前
  beforeUpdate() { }, //生命周期 - 更新之前
  updated() { }, //生命周期 - 更新之后
  beforeDestroy() { }, //生命周期 - 销毁之前
  destroyed() { }, //生命周期 - 销毁完成
  activated() { } //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang="less" scoped>
@import "./service.less";
.card:first-child {
  margin-top: 0;
}
</style>
